<nx-popover #disabledPopover>{{ 'add-document.disabled.tooltip' | translate }}</nx-popover
><nx-file-uploader
  #fileUploader
  [value]="value()"
  (filesSelected)="filesSelected($event)"
  (fileDeleted)="fileDeleted($event)"
  multiple
  [accept]="acceptedMimeTypes().join(',')"
  [disabled]="!userService.permissions().writeDocument"
  [maxFileSize]="maxFileSize"
  [maxFileNumber]="maxFileNumber()"
>
  <nx-label size="small" class="nx-margin-bottom-3xs">
    {{ 'file-uploader.title' | translate }}
    @if (showOptional()) {
      <span> ({{ 'file-uploader.title.optional' | translate }})</span>
    }
  </nx-label>
  <span class="nx-margin-bottom-3xs" nxFileUploadHint>{{
    maxFileNumber()
      ? ('file-uploader.max-files' | translate: { maxFileNumber: maxFileNumber() })
      : ('file-uploader.multiple-files' | translate)
  }}</span>
  <span class="nx-margin-bottom-s" nxFileUploadHint>{{ 'file-uploader.maximum-size-10MB' | translate }}</span>
  <nx-file-uploader-drop-zone
    class="nx-margin-bottom-m"
    data-testid="file-dropzone"
    [nxPopoverTriggerFor]="disabledPopover"
    [nxPopoverTrigger]="userService.permissions().writeDocument ? 'manual' : 'hover'"
    nxPopoverDirection="top"
  >
    <span nxCopytext class="nx-margin-right-2xs nx-hidden-xs nx-hidden-s"
      >{{ 'file-uploader.drag-files' | translate }}
    </span>
    <button nxButton="primary small-medium" type="button" nxFileUploadButton>
      <nx-icon name="plus" class="nx-margin-right-2xs" aria-hidden="true" />
      {{ 'file-uploader.button' | translate }}
    </button>
  </nx-file-uploader-drop-zone>
  @if (fileUploader?.errors?.length) {
    <nx-error>
      <div class="nx-font-weight-bold">{{ 'file-uploader.error' | translate }}</div>
      <ul class="list-disc">
        @for (error of fileUploader?.errors; track error) {
          <li>
            @if (error.type === 'fileNumber') {
              {{ 'file-uploader.max-files' | translate: { maxFileNumber: maxFileNumber() } }}
            }
            @if (error.filename; as filename) {
              @if (error.type === 'fileType') {
                {{ 'file-uploader.file-extension-not-supported' | translate: { filename } }}
              }
              @if (error.type === 'fileSize') {
                {{ 'file-uploader.file-exceeds-size-limit' | translate: { filename } }}
              }
            }
          </li>
        }
      </ul>
    </nx-error>
  }
</nx-file-uploader>
